import { Theme } from "@shared/lib/constants/themes";
import { computed, ref, Ref } from "vue";
import useTheme from "./useTheme";

export default function (theme: Ref<keyof typeof Theme | null | undefined> = ref()) {
  const computedTheme = computed(() => theme.value || localStorage.getItem("theme") as keyof typeof Theme | null);

  const {
    isDarkColor,
  } = useTheme(ref(document.documentElement), computedTheme, handleThemeChange);

  function handleThemeChange ({
    primaryColor,
  }: {
    primaryColor: string,
    secondaryColor: string,
  }) {
    if (computedTheme.value) localStorage.setItem("theme", computedTheme.value);

    document.documentElement.style.setProperty("--themeColorPrimary", `var(--themeColorPrimary${computedTheme.value}, var(--themeColorPrimaryLosAngelesLakers))`);
    document.documentElement.style.setProperty("--themeColorSecondary", `var(--themeColorSecondary${computedTheme.value}, var(--themeColorSecondaryLosAngelesLakers))`);

    const themeColorMeta = document.head.querySelector("meta[name='theme-color']");
    themeColorMeta?.setAttribute("content", primaryColor);
  }

  return {
    theme: computedTheme,
    isDarkColor,
  };
}
